import { BaseApiService } from "./base";

const API_ENDPOINT = "/api/v4/pages";

export class PagesApiService extends BaseApiService {
  public getPrivacyPolicy = () => this.axios.get<Pages.ApiResponse>(`${API_ENDPOINT}/privacy_policy`);
  public getTermsAndConditions = () => this.axios.get<Pages.ApiResponse>(`${API_ENDPOINT}/terms_conditions`);
}
